//param appManagementModel : AppManagementModel
//required to convert booleans to correct data types for serialization within api
export function convertIntBoolFlags(appManagementModel) {
	//convert patientData type to byte
	appManagementModel.appMaster.patientData
		? (appManagementModel.appMaster.patientData = '1')
		: (appManagementModel.appMaster.patientData = '0');

	return appManagementModel;
}
